import { Link } from "react-router-dom";
import { ArrowRight, Server, FileText, Cpu } from "lucide-react";
import WaitlistForm from "@/components/WaitlistForm";

export default function FinalCTA() {
    return (
        <section className="relative py-16 sm:py-24 md:py-32 lg:py-40 border-t border-line overflow-hidden" data-testid="final-cta">
            <div className="absolute inset-0 hero-glow-bg pointer-events-none" />
            <div className="absolute inset-0 dot-grid opacity-40 pointer-events-none" />

            <div className="relative max-w-5xl mx-auto px-5 sm:px-6 md:px-10 text-center">
                <div className="overline mb-5">Internet 3.0</div>
                <h2 className="font-heading font-black text-[2rem] sm:text-5xl lg:text-6xl leading-[1.04] tracking-tight text-ink">
                    Internet 3.0 Needs<br />
                    Its Own <span className="brand-gradient-text">Cloud Protocol.</span>
                </h2>
                <p className="mt-6 sm:mt-7 text-[15px] sm:text-base md:text-lg text-muted-ink max-w-2xl mx-auto leading-relaxed">
                    DeCloudX is building the hybrid-decentralized cloud protocol where developers deploy, AI runs, nodes earn, data stays encrypted, and every workload is settled on-chain.
                </p>

                <div className="mt-8 sm:mt-10 flex flex-wrap items-center justify-center gap-3">
                    <Link to="/contact" className="group btn-primary" data-testid="final-cta-join">
                        Join DeCloudX Network
                        <ArrowRight size={16} strokeWidth={2} className="group-hover:translate-x-1 transition-transform" />
                    </Link>
                    <Link to="/contact?role=node_operator" className="btn-secondary" data-testid="final-cta-node">
                        <Server size={15} strokeWidth={1.5} className="text-brand-cyan" />
                        Become a Node Operator
                    </Link>
                    <Link to="/layer-1" className="btn-secondary" data-testid="final-cta-layer1">
                        <Cpu size={15} strokeWidth={1.5} className="text-brand-violet" />
                        Explore Layer-1
                    </Link>
                    <Link to="/whitepaper" className="btn-ghost" data-testid="final-cta-whitepaper">
                        <FileText size={15} strokeWidth={1.5} />
                        Read Whitepaper
                    </Link>
                </div>

                <div className="mt-12 sm:mt-16">
                    <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-faint-ink mb-5">
                        Reserve early-access spot
                    </div>
                    <WaitlistForm />
                </div>
            </div>
        </section>
    );
}
